import dayjs from 'dayjs'

/** Two-letter initials for avatar bubbles ("Renee Alvarez" → "RA"). */
export function msgInitials(name) {
	return (name || '')
		.trim()
		.split(/\s+/)
		.map(w => w[0])
		.slice(0, 2)
		.join('')
		.toUpperCase() || '?'
}

/** Compact timestamp for conversation rows: 9:48 AM / Yesterday / Wed / Jun 3. */
export function formatListTime(timestamp) {
	const now = dayjs()
	const msgTime = dayjs(timestamp)
	const diffDays = now.diff(msgTime, 'day')
	if (diffDays === 0) return msgTime.format('h:mm A')
	if (diffDays === 1) return 'Yesterday'
	if (diffDays < 7) return msgTime.format('ddd')
	return msgTime.format('MMM D')
}

/** Day-separator label: Today / Yesterday / Wednesday · Jun 10 / Jun 10, 2025. */
export function dayLabel(timestamp) {
	const m = dayjs(timestamp)
	if (m.isSame(dayjs(), 'day')) return 'Today'
	if (m.isSame(dayjs().subtract(1, 'day'), 'day')) return 'Yesterday'
	if (m.isSame(dayjs(), 'year')) return m.format('dddd · MMM D')
	return m.format('MMM D, YYYY')
}

/** "142 · 1 SMS" style counter for the composer (160 chars per segment). */
export function smsCounter(text) {
	const chars = text.length
	if (!chars) return 'SMS'
	const segs = Math.max(1, Math.ceil(chars / 160))
	return `${chars} · ${segs} SMS`
}

// Fallback category accents (design: grooming blue, boarding amber, daycare
// green). Used when a service has no appointment_color of its own.
const CATEGORY_COLORS = {
	grooming: '#3E9BD0',
	boarding: '#D9912F',
	daycare: '#46A06E',
}

/** Accent color for an upcoming-appointment card. */
export function categoryColor(serviceType) {
	if (serviceType?.appointment_color) return serviceType.appointment_color
	const cat = (serviceType?.category || '').toLowerCase()
	for (const [key, color] of Object.entries(CATEGORY_COLORS)) {
		if (cat.includes(key)) return color
	}
	return CATEGORY_COLORS.grooming
}
